export const baseURL = `${process.env.REACT_APP_BACKEND_API}api/v1/admin`;
export const baseURL_For_IMG_UPLOAD = `${process.env.REACT_APP_BACKEND_API}upload`;
export const baseURL_For_IMG_DELETE = `${process.env.REACT_APP_BACKEND_API}delete-image`;
export const API_URL = `${process.env.REACT_APP_BACKEND_API2}`;

export const baseURL_For_DOMAIN = `${process.env.REACT_APP_PRIMARY_DOMAIN}`;

// Socket URL (defaults to backend origin)
export const SOCKET_URL = `${process.env.REACT_APP_SOCKET_IO_URL}`;
